import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuthUserContext } from '../../providers';
import { UserType } from '../../types';
import DoneeForumList from './DoneeForumList';
import ForumNew from './ForumNew';
import ForumEdit from './ForumEdit';
import DoneeForumApplications from './DoneeForumApplications';
import DonorApplicationList from './DonorApplicationList';

const MypageForum = () => {
  const authUser = useAuthUserContext().user;
  const isDonee = authUser?.userType === UserType.Donee;

  return (
    <main className="sub">
      <Routes>
        <Route path="new" element={ isDonee ? <ForumNew /> : null } />
        <Route path=":id/edit" element={ isDonee ? <ForumEdit /> : null } />
        <Route path=":id/applications" element={ isDonee ? <DoneeForumApplications /> : null } />
        <Route path="" element={ isDonee ? <DoneeForumList /> : <DonorApplicationList /> } />
      </Routes>
    </main>
  );
};

export default MypageForum;
